import { Fragment, FC, MutableRefObject } from "react"
import { ChangeType } from "../../api/EventTypes"
import Input from "../../components/generic/form/Input"

export interface IFormProps {
  value: {
    [key: string]: any
  }
  onChange: (e: ChangeType) => void
  onBlur: (e: ChangeType) => void
  inputRef?: MutableRefObject<HTMLInputElement>
}
const PassPhraseForm: FC<IFormProps> = ({
  value,
  onChange,
  onBlur,
  inputRef
}) => {
  return (
    <Fragment>
      <Input
        type="password"
        value={value.first}
        name="first"
        onChange={onChange}
        inputIdentifier="first"
        onBlur={onBlur}
        maxLength={1}
        autoFocus
      />
      <span className="ocs-separator" />
      <Input
        type="password"
        value={value.second}
        name="second"
        onChange={onChange}
        inputIdentifier="second"
        onBlur={onBlur}
        maxLength={1}
        inputRef={inputRef}
      />
    </Fragment>
  )
}

export default PassPhraseForm
